var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSohasIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 20,
    rx: 24,
    ry: 20,
    fill: "#F0932E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 15.5C18 18.3599 16.12 20.5 14 20.5C11.88 20.5 10 18.3599 10 15.5C10 12.6401 11.88 10.5 14 10.5C16.12 10.5 18 12.6401 18 15.5Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 15.5C38 18.3599 36.12 20.5 34 20.5C31.88 20.5 30 18.3599 30 15.5C30 12.6401 31.88 10.5 34 10.5C36.12 10.5 38 12.6401 38 15.5Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 29H8C8 29 9.03035 24.3634 12.5 20.5248C14.9508 17.8133 18.6186 15.5 24 15.5C25.9627 15.5 27.6974 15.8077 29.2283 16.3302C31.8949 17.2404 33.9431 18.8022 35.5 20.5248C38.9696 24.3634 40 29 40 29H31.5H16.5Z",
    fill: "#F0932E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 29H8C8 29 9.03035 24.3634 12.5 20.5248M16.5 29L12.5 20.5248M16.5 29H31.5M12.5 20.5248C14.9508 17.8133 18.6186 15.5 24 15.5C25.9627 15.5 27.6974 15.8077 29.2283 16.3302C31.8949 17.2404 33.9431 18.8022 35.5 20.5248M31.5 29H40C40 29 38.9696 24.3634 35.5 20.5248M31.5 29L35.5 20.5248",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 29.5218V19.4792C17 19.4792 19.0489 19.0242 20.3833 19.001C21.9049 18.9746 24.25 19.4792 24.25 19.4792V30C24.25 30 22.2356 29.1621 20.8667 29.0435C19.3507 28.9121 17 29.5218 17 29.5218Z",
    fill: "#F0932E",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 29.5218V19.4792C31.5 19.4792 29.4511 19.0242 28.1167 19.001C26.5951 18.9746 24.25 19.4792 24.25 19.4792V30C24.25 30 26.2644 29.1621 27.6333 29.0435C29.1493 28.9121 31.5 29.5218 31.5 29.5218Z",
    fill: "#F0932E",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28 12.5C28 15.3599 26.12 17.5 24 17.5C21.88 17.5 20 15.3599 20 12.5C20 9.64008 21.88 7.5 24 7.5C26.12 7.5 28 9.64008 28 12.5Z",
    fill: "#F0932E",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSohasIcon);
export default __webpack_public_path__ + "static/media/sohas-icon.e68e7a64.svg";
export { ForwardRef as ReactComponent };